export const COOKIE_NAME = process.env.REACT_APP_COOKIES_POLICY_NAME
export const DOMAIN = process.env.REACT_APP_DOMAIN_URL
export const API_VERSION = process.env.REACT_APP_API_VERSION